import {PDFViewer, Document, Image, Page, Text, StyleSheet, View, Font} from "@react-pdf/renderer";
import {Table, TableHeader, TableCell, TableBody, DataTableCell} from "@david.kucsai/react-pdf-table";
import logo from "./logo.png";
import React from "react";
import {image} from "./config";


Font.register({
    family: 'Helvetica',
});
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: 'Helvetica',
    },
    view: {
        marginBottom: 15,
        fontSize: 12
    },
    tableHeader: {
        textAlign: 'center',
        padding: 6,
        fontSize: 12,
        backgroundColor: '#C4C5CE'
    },
    fixed: {
        marginBottom: 15,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    title: {
        fontWeight: 'semibold',
        padding: 6,
        color: 'white',
        backgroundColor: '#00a3e0'
    },
    pagination: {
        marginTop: 5,
        fontSize: 11
    },
});

function Renderer({data, title}) {

    const prewrap = (text) =>  {
        if(!text) return '';
        text = text + '';
        return text.replace(/<div>/gi,"\n").replace(/<\/div>/gi,"").replace(/<br>/gi,"\n");
    };

    const renderNode = (index, node) =>   {
        var block = null;
        if (node.element === "text") {
            block = <Text wrap style={{textAlign: node.align || 'left', fontSize: node.font}}>{prewrap(node.text)}</Text>
        }
        if (node.element === "title") {
            block = <Text style={{...styles.title, textAlign: node.align || 'left', fontSize: node.font}} wrap>{prewrap(node.text)}</Text>
        }
        else if(node.element === "image") {
            if(!node.image) return null;
            block = <Image src={image(node.image)} style={{width: node.width ? node.width + '%' : 'auto'}} />
            if(node.align) {
                let align = node.align === "right" ? "flex-end" : node.align;
                block = <View key={index} style={{width: '100%', alignItems: align}}>
                    {block}
                </View>
            }
        }
        else if(node.element === "new page") {
            return <View key={index} break>
                <Text> </Text>
            </View>
        }
        else if(node.element === "table") {
            block = <Table data={node.rows}>
                    {node.text
                    ? <TableHeader>
                        <TableCell>
                            <Text style={styles.tableHeader}>{node.text}</Text>
                        </TableCell>
                    </TableHeader>
                    : null}

                    <TableBody>
                        {[...Array(node.table_cols || 3)].map((_, index) => {
                            const id = index + 1;
                            return <DataTableCell
                                    style={{ justifyContent: 'center', fontSize: 11}}
                                    weighting={node[`col_${id}_width`] ? parseInt(node[`col_${id}_width`])/100 : 1}
                                    getContent={(r) => {
                                        if(r[`image_${id}`]) {
                                            return <View key={index} style={{padding: 8, alignItems: node.align ? node.align === "right" ? "flex-end" : node.align : 'flex-start'}}>
                                                <Image src={image(r[`image_${id}`])} style={{maxWidth: r[`image_${id}`].width}} />
                                            </View>
                                        }
                                        return <Text style={{padding: 8, textAlign: node.align || 'left', fontSize: node.font, ...(r[`field_${id}`]?.style || {})}}>
                                            {prewrap(r[`field_${id}`]?.text || r[`field_${id}`])}
                                        </Text>
                                    }} />
                        })}
                    </TableBody>
                </Table>

            {/*const chunks = node.rows.reduce((acc, _, i) => {
                    if (i % 5 === 0) acc.push(node.rows.slice(i, i + 5));
                    return acc;
                }, [])

            return <View key={index} style={styles.view}>
                {chunks.map((rows, id) => {
                    return <View key={id} style={{margin: 0}}>
                        <Text style={{margin: 0}}> </Text>
                        <Table index={id} data={rows}>
                    {(node.text && id === 0)
                    ? <TableHeader>
                        <TableCell>
                            <Text style={styles.tableHeader}>{node.text}</Text>
                        </TableCell>
                    </TableHeader>
                    : null}

                    <TableBody>
                        {[...Array(node.table_cols || 3)].map((_, index) => {
                            const id = index + 1;
                            return <DataTableCell
                                    style={{ justifyContent: 'center', fontSize: 11}}
                                    weighting={node[`col_${id}_width`] ? parseInt(node[`col_${id}_width`])/100 : 1}
                                    getContent={(r) => {
                                        if(r[`image_${id}`]) {
                                            return <View key={index} style={{padding: 8, alignItems: node.align ? node.align === "right" ? "flex-end" : node.align : 'flex-start'}}>
                                                <Image src={image(r[`image_${id}`])} style={{maxWidth: r[`image_${id}`].width}} />
                                            </View>
                                        }
                                        return <Text style={{padding: 8, textAlign: node.align || 'left', fontSize: node.font, ...(r[`field_${id}`]?.style || {})}}>
                                            {prewrap(r[`field_${id}`]?.text || r[`field_${id}`])}
                                        </Text>
                                    }} />
                        })}
                    </TableBody>
                </Table>
                    </View>
                })}

            </View>*/}
        }
        return <View key={index} style={styles.view}>
            {block}
        </View>
    }

    return  <PDFViewer style={{width: '100%', height: '100%', border: "none"}}>
        <Document onLoadError={(err) => {
            console.log(err)
        }}>
            <Page wrap style={styles.page}>

                <View  render={({ pageNumber, totalPages }) => (
                    <View style={styles.fixed}>
                        <Text style={styles.pagination} render={({ pageNumber, totalPages }) => (
                            `Page ${pageNumber} of ${totalPages}`
                        )} />
                        <Image src={logo} style={{width: 120}} />
                    </View>
                )} fixed />

                {data.map((node, index) => {
                    return renderNode(index, node);
                })}

            </Page>
        </Document>
    </PDFViewer>
}
export default Renderer;